const appparameters = require("./common.jsx");

export const manageRequest = async (
  option,
  request,
  token,
  username,
  sasDevice
) => {
  try {
    const response = await fetch(
      `${appparameters.backend_app_url}/frontend/managerequest`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userData: {
            request: request, // e.g., "Get Log"
            token: token,
            username: username,
            option: option, // e.g., add, delete, check
            device: sasDevice,
          },
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    if (typeof data === "boolean") {
      console.log(`option: ${option}, request: ${request}, data: ${data}`);
      return data;
    } else {
      console.error("Unexpected response type");
      return false;
    }
  } catch (error) {
    console.error("Error processing request:", error);
    return false;
  }
};
export const fetchLogsFromServer = async (targetFile, mac) => {
  //console.log("fetchLogsFromServer:" + targetFile);
  try {
    const response = await fetch(
      appparameters.backend_app_url + `/frontend/getSurfLogs`,
      {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userData: {
            tag: mac,
            token: localStorage.getItem("token"),
            username: localStorage.getItem("username"),
            file: targetFile,
          },
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data.content) {
      return data.content;
    } else {
      console.error("No content in response");
      return null;
    }
  } catch (error) {
    console.error("Error fetching file content:", error);
    return null;
  }
};
export const returnedsurflogStatus = [
  "No File Transfer",
  "No Json Files Found",
  "No Log Files Found",
  "Uploading Files Started",
  "Uploading Files Succeeded",
  "Uploading Files Failed",
  "Uploading Files Aborted By User",
];
export function translateJsonFileName(jsonFileDir) {
  // Split the directory path by "\\" to get the individual parts
  const parts = jsonFileDir.split(jsonFileDir.includes("\\") ? "\\" : "/");

  // Extract the second and third parts
  const part1 = parts[1];
  const part2 = parts[2];
  let numberMatch = undefined;

  if (part2 != undefined) {
    // Extract the number from the filename part
    numberMatch = part2.toLowerCase().match(/_(\d+)\.jsn$/);
  } else {
    return "0_0";
  }

  // Check if the match was successful
  if (numberMatch) {
    const part3 = numberMatch[1];

    // Combine the parts to get the desired format
    const result = `${part1}_${part3}`;
    return result;
  } else {
    // If the match was not successful, return an error message
    return "0_0";
  }
}
export function translateBinFileName(inputString) {
  let underscoreCount = (inputString.match(/_/g) || []).length;
  if (underscoreCount < 3) {
    let dotIndex = inputString.toLowerCase().lastIndexOf(".bin");
    if (dotIndex !== -1) {
      inputString =
        inputString.slice(0, dotIndex) + "_0_0" + inputString.slice(dotIndex);
    } else {
      inputString += "_0_0";
    }
  }
  return inputString;
}
export function calculateTotalProgress(
  totalFiles,
  currentFileIndex,
  fileProgress
) {
  // Calculate progress contributed by the fully uploaded files
  const completedFilesProgress = ((currentFileIndex - 1) / totalFiles) * 100;

  // Calculate total progress including the current file's progress
  const totalProgress = completedFilesProgress + fileProgress / totalFiles;

  return totalProgress.toFixed(2); // Return total progress rounded to two decimal places
}
